import { useEffect, useState } from 'react';
import { Save } from 'lucide-react';
import { toast } from 'sonner';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { useUpdateBillingMeta } from '../../hooks/queries/useBillingDocuments';

interface Props {
  documentId: string;
  initialNotes: string;
}

export function BillingNotesEditor({ documentId, initialNotes }: Props) {
  const [value, setValue] = useState(initialNotes);
  const mut = useUpdateBillingMeta(documentId);

  useEffect(() => {
    setValue(initialNotes);
  }, [initialNotes]);

  const dirty = value !== initialNotes;

  async function save() {
    try {
      await mut.mutateAsync({ notes: value });
      toast.success('Notes enregistrées');
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Erreur');
    }
  }

  return (
    <Card
      header={
        <div className="flex items-center justify-between">
          <span className="text-sm font-semibold text-neutral-700">Notes de pied</span>
          {dirty && (
            <Button variant="primary" size="sm" onClick={save} isLoading={mut.isPending}>
              <Save className="w-3.5 h-3.5 mr-1" /> Enregistrer
            </Button>
          )}
        </div>
      }
    >
      <textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        rows={3}
        placeholder="Conditions de paiement, références dossier, mentions particulières…"
        className="w-full px-3 py-2 text-sm rounded-cime border border-neutral-300 focus:outline-none focus:ring-1 focus:ring-cime-primary resize-y min-h-[5rem]"
      />
    </Card>
  );
}
